export default "__VITE_ASSET__b82a4bc9__"